import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { MenuController, IonInput } from '@ionic/angular';
import { FormGroup, FormBuilder } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { AlertService } from '../../../services/alert.service';
import { ToastService } from '../../../services/toast.service';
import { AuthService } from '../../../services/auth.service';
import { LoadingService } from '../../../services/loading.service';
import { ValidationUtil } from '../../../utils/validation';
import { Router, ActivatedRoute } from '@angular/router';
//import { MenuConfig } from '../../../types/MenuConfig';
import { Capacitor } from '@capacitor/core';
import { ReceivedMessage, RegisterReceiver, SmsRetriever } from 'capacitor-sms-retriever';
import { AnalyticsService } from 'src/app/services/analytics.service';
import { ContentService } from 'src/app/services/content.service';

@Component({
  selector: 'app-verify-login',
  templateUrl: './verify-login.page.html',
  styleUrls: ['./verify-login.page.scss', '../authentication.scss'],
})
export class VerifyLoginPage implements OnInit, AfterViewInit {
  title = 'Enter Code';
  verifyCodeForm: FormGroup;
  fieldNames = {
    code: 'SMS Code',
  };
  phone!: string;
  currentUser: any;
  showResendButton = true;
  smsReceiverResponse!: RegisterReceiver;
  @ViewChild('code', { static: true }) code!: IonInput;

  constructor(public router: Router,
    public route: ActivatedRoute,
    private menuCtrl: MenuController,
    private docTitle: Title,
    private formBuilder: FormBuilder,
    private alertProvider: AlertService,
    private toastProvider: ToastService,
    private amplifyProvider: AuthService,
    private loadingProvider: LoadingService,
    private analyticsService: AnalyticsService,
    private contentService: ContentService,
  ) {
    this.analyticsService.tagRoute('unauthenticated/verifylogin');
    this.menuCtrl.enable(false, 'left');
    this.menuCtrl.enable(false, 'right');
    this.docTitle.setTitle(this.title);

    route.queryParams.subscribe(params => {
      this.phone = params['phone'];
    });

    this.verifyCodeForm = this.formBuilder.group({
      code: ['', [ValidationUtil.isRequired]]
    });
  }

  async ngOnInit() {
    SmsRetriever.getAppSignature().then((signature) => {
      console.log('sss22', signature);
    });

    await this.registerSmsRetriever();
  }

  ngAfterViewInit() {
    this.focusOnInput();
  }

  async registerSmsRetriever() {
    if (this.smsReceiverResponse?.isRegistered) {
      await SmsRetriever.removeSmsReceiver();
    }

    this.smsReceiverResponse = await SmsRetriever.startSmsReceiver();

    if (this.smsReceiverResponse?.isRegistered) {
      const smsReceiveListener = await SmsRetriever.addListener('onSmsReceive', (receivedMessage: ReceivedMessage) => {
        if (!receivedMessage.error) {
          this.processSms(receivedMessage.message || "");
          smsReceiveListener.remove();
        }
      });
    }
  }

  processSms(message: string) {
    try {
      if (message) {
        const res = message.match('[0-9]{1,6}');

        if (res && res.length) {
          this.verifyCode();
        }
      }
    } catch (e) {
      console.error(e);
    }
  }

  verifyCode(): void {
    this.analyticsService.tagButtonPress('verifylogin_page', 'verify_code');
    if (Capacitor.isNativePlatform() && this.isDemoUser()) {
      this.handleDemoUser();
    } else {
      if (this.verifyCodeForm.valid) {
        this.submitForm();
      } else {
    this.alertProvider.showEmptyForm();
      }
    }
  }

  submitForm() {
    this.loadingProvider.loadWhile(async (stopLoading) => {
      try {
        if (Capacitor.isNativePlatform()) {
          const password = this.amplifyProvider.generateNewPassword();
          await this.amplifyProvider.submitForgotPassword(this.phone, this.verifyCodeForm.value.code, password);
          await this.authenticateUser(password);
        } else {
          await this.amplifyProvider.submitVerifySMSCode(this.verifyCodeForm.value.code, this.currentUser);

          if (this.smsReceiverResponse?.isRegistered) {
            await SmsRetriever.removeSmsReceiver();
          }
        }
        this.contentService.setLocale('en');
        this.router.navigate(['/plan']);
      } catch (error) {
        console.log('error', error);
        await this.registerSmsRetriever();
        console.error(error);
        this.handleError(error);
      }
      finally {
        stopLoading();
      }
    });
  }


  async authenticateUser(password: string) {
    try {
      const user = await this.amplifyProvider.login(this.phone, password);
      if (this.smsReceiverResponse?.isRegistered) {
        await SmsRetriever.removeSmsReceiver();
      }
      // this.router.navigate(['Tabs']);
    } catch (error) {
      await this.registerSmsRetriever();
      console.error(error);
      this.alertProvider.showAmplifyAuthError(error);
    }
  }

  sendSignUpCode(phone: string) {
    this.loadingProvider.loadWhile(stopLoading => {
      this.amplifyProvider.resendSignUpCode(phone)
        .then(() => {
          stopLoading();
          this.toastProvider.show(`We sent a SMS to ${phone} with a code, please enter it here.`);
          this.handleNavigation();
        })
        .catch(error => {
          stopLoading();
          this.alertProvider.showAmplifyAuthError(error);
        });
    });
  }

  handleNavigation() {
    // Pop current page 'VerifyLoginPage' from navigation stack
    // Push to 'VerifySignUpPage'
    // Don't forget to pass in the phone number
    // Disable animations
    this.router.navigate(['unauthenticated/verifysignup'], { queryParams: { phone: this.phone } });
  }

  resendCode() {
    this.analyticsService.tagButtonPress('verifylogin_page', 'resend_code');
    if (Capacitor.isNativePlatform()) {
      if (this.isDemoUser()) {
        this.toastProvider.show(`Hi Demo User. Your SMS Code is "000000".`);
      } else {
        this.loadingProvider.loadWhile(stopLoading => {
          this.amplifyProvider.sendForgotPasswordCode(this.phone)
            .then(() => {
              stopLoading();
              this.toastProvider.show(`We sent a SMS to ${this.phone} with a code, please enter it here.`);
            })
            .catch(error => {
              stopLoading();
              this.handleError(error);
            });
        });
      }
    } else {
      this.amplifyProvider.sendSMSCode(this.phone)
        .then(() => {
          this.toastProvider.show(`We sent a SMS to ${this.phone} with a code, please enter it here.`);
          //this.handleNavigation();
        })
        .catch(error => {
          this.alertProvider.showAmplifyAuthError(error);
        });
    }
    this.showResendButton = false;
    const timeout = setTimeout(() => {
      this.showResendButton = true;
      clearTimeout(timeout);
    }, 1000 * 30);
  }

  focusOnInput() {
    setTimeout(() => {
      if (this.code) {
        this.code.setFocus();
      }
    }, 200);
  }

  // ----------- DEMO User Methods -------------------- //
  /**
   * Instructions for Demo user
   * Use Phone number 0400000000, (+610400000000 or +61400000000 or 400000000)
   * Click on "I have a code" button
   * Use SMS code "000000"
   */

  isDemoUser() {
    return this.phone.endsWith('000000');
  }

  handleDemoUser() {
    return this.verifyCodeForm.valid
      ? this.authenticateDemoUser()
      : this.alertProvider.showEmptyForm();
  }

  isFakeCode() {
    return this.verifyCodeForm.value.code === '000000';
  }

  authenticateDemoUser() {
    if (this.isFakeCode()) {
      const password = 'password';
      this.loadingProvider.loadWhile(stopLoading => {
        this.amplifyProvider.login(this.phone, password)
          .then((user) => {
            stopLoading();
            this.router.navigate(['/plan']);
          }).catch(error => {
            stopLoading();
              this.alertProvider.showAmplifyAuthError(error);
          });
      });
    } else {
        this.alertProvider.show(`Hi Demo User`, `Your SMS Code doesn't match. Request a new one.`);
    }
  }

  // TODO :: Make this better (switch statement in a Service?)
  // https://docs.aws.amazon.com/cognito-user-identity-pools/latest/APIReference/API_ForgotPassword.html

  handleError(error: any) {
    console.error(error);
    if (this.maybeUserNotConfirmed(error)) {
      this.sendSignUpCode(this.phone);
    } else if (this.amplifyProvider.isUserLambdaValidationException(error)) {
      this.showServerSideAlert(error);
    } else if (this.amplifyProvider.isUnexpectedLambdaException(error)) {
      this.showServerSideAlert(error);
    } else if (this.amplifyProvider.isInvalidLambdaResponseException(error)) {
      this.showServerSideAlert(error);
    } else if (this.amplifyProvider.isInternalErrorException(error)) {
      this.showServerSideAlert(error);
    } else if (this.amplifyProvider.isCodeMismatchException(error) || this.amplifyProvider.isExpiredCodeException(error)) {
      this.alertProvider.show('Incorrect SMS Code', 'Check and re-enter, or touch send a new code');
    } else if (this.amplifyProvider.isTooManyRequestsException(error) ||
      this.amplifyProvider.isTooManyFailedAttemptsException(error) || this.amplifyProvider.isLimitExceededException(error)) {
      this.alertProvider.show(
        'Please try again later',
        'We\'ve detected an unusual amount of activity from this phone number. We apologise for any inconvenience.'
      );
    } else {
      this.alertProvider.showAmplifyAuthError(error);
    }
  }

  maybeUserNotConfirmed(error: any) {
    // this is an educated guess that the user is in an UNCONFIRMED state
    // and needs a signUpCode instead of a forgotPasswordCode
    return this.amplifyProvider.isInvalidParameterException(error) || this.amplifyProvider.isUserNotConfirmedException(error);
  }

  showServerSideAlert(error: any) {
    this.alertProvider.confirm(
      `Something went wrong on our side`,
      `${error.code}`,
      `Contact us`,
      () => {
        this.contactUs();
      }
    );
  }

  contactUs() {
    this.router.navigate(['unauthenticated', 'contactus']);
  }


}
